import React, { useState } from "react";
import "./RCParticulars.css";

export default function RCParticulars() {

  const [rc, setRc] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [pdf, setPdf] = useState(null);

  const submitHandler = async () => {
    if (!rc.trim()) {
      alert("Please enter RC Number");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/rc_particulars.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          rcNumber: rc,
          user_id: JSON.parse(localStorage.getItem("user")).id
        }),
      });

      const result = await res.json();
      setLoading(false);

      if (result.status === "error") {
        alert(result.message);
        return;
      }

      setData(result.data);
      setPdf(result.pdf);

    } catch (err) {
      setLoading(false);
      alert("Server Error ❌");
    }
  };

  return (
    <div className="rc-container">

     <h2 className="title">RC Particulars at 99/-</h2>

<p className="sub-title">
  <span className="dot"></span>
  You Can Download PDF After Getting Details / 
  आर सी की डिटेल्स आने के बाद आप उसकी पीडीऍफ़ भी डाउनलोड क्र सकते है
</p>

      {/* ⭐ White Shadow Box */}
      <div className="rc-input-card">
        <div className="rc-box">
          <input
            className="rc-input"
            placeholder="Enter RC Number"
            value={rc}
            onChange={(e) => setRc(e.target.value.toUpperCase())}
            maxLength={12}
          />

          <button className="rc-btn" onClick={submitHandler} disabled={loading}>
            {loading ? "Processing..." : "Get Details at 99/-"}
          </button>
           <a
    href="/sample/rc_sample.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="sample-btn"
  >
    View Sample
  </a>
        </div>
      </div>


      {data && (
        <div className="result-card">

          <h3 className="result-title">Vehicle Details</h3>

          <table className="result-table">
            <tbody>

              <tr><th>Registration Number</th><td>{data.registration?.number}</td></tr>
              <tr><th>RTO</th><td>{data.registration?.authority}</td></tr>
              <tr><th>Owner Serial No.</th><td>{data.registration?.ownerCount}</td></tr>
              <tr><th>Owner Name</th><td>{data.registration?.owner?.name}</td></tr>
              <tr><th>Father Name</th><td>{data.registration?.owner?.fatherName}</td></tr>
              <tr><th>Present Address</th><td>{data.registration?.owner?.presentAddress}</td></tr>
              <tr><th>Permanent Address</th><td>{data.registration?.owner?.permanentAddress}</td></tr>
              <tr><th>Ownership</th><td>{data.registration?.owner?.ownershipType}</td></tr>
              <tr><th>Registration Date</th><td>{data.registration?.date}</td></tr>
              <tr><th>Expiry Date</th><td>{data.registration?.expiryDate}</td></tr>
              <tr><th>Vehicle Class</th><td>{data.vehicle?.class}</td></tr>
              <tr><th>Vehicle Model</th><td>{data.vehicle?.model}</td></tr>
              <tr><th>Manufacturer</th><td>{data.vehicle?.manufacturer}</td></tr>
              <tr><th>Fuel Type</th><td>{data.vehicle?.fuelType}</td></tr>
              <tr><th>Color</th><td>{data.vehicle?.color}</td></tr>
              <tr><th>Fuel Norms</th><td>{data.vehicle?.normsType}</td></tr>
              <tr><th>Chassis Number</th><td>{data.vehicle?.chassis}</td></tr>
              <tr><th>Engine Number</th><td>{data.vehicle?.engine}</td></tr>
              <tr><th>Month Of Manufacture</th><td>{data.vehicle?.manufacturingYear}</td></tr>
              <tr><th>Cubic Capacity</th><td>{data.vehicle?.cubicCapacity}</td></tr>
              <tr><th>Laden/Gross Weight</th><td>{data.vehicle?.grossWeight}</td></tr>
              <tr><th>UnLaden Weight</th><td>{data.vehicle?.unladenWeight}</td></tr>
              <tr><th>Wheel Base</th><td>{data.vehicle?.wheelbase}</td></tr>
              <tr><th>No of Cylinders</th><td>{data.vehicle?.cylinders}</td></tr>
              <tr><th>No of Seats</th><td>{data.vehicle?.seatCapacity}</td></tr>
              <tr><th>Body Type</th><td>{data.vehicle?.bodyType}</td></tr>
              <tr><th>Type</th><td>{data.vehicle?.category}</td></tr>
              <tr><th>BHP</th><td>{data.vehicle?.bhp}</td></tr>
              <tr><th>Financer</th><td>{data.finance?.rcFinancer}</td></tr>

            </tbody>
          </table>

          {pdf && (
            <a href={`https://rcfinder.online/api/${pdf}`} target="_blank" rel="noopener noreferrer">
              <button className="pdf-btn">
                Download PDF
              </button>
            </a>
          )}

        </div>
      )}
    </div>
  );
}
